/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal, userData, switchModal } from '../../actions';
import Girl from '../../assets/login/girl.svg';
import X from '../../assets/login/x.svg';

class Register1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.email,
      password: '',
      firstname: this.props.firstName,
      lastname: this.props.lastName,
      firstNameError: false,
      lastNameError: false,
      passwordError: false,
      emailError: false,
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNext = () => {
    this.setState((prevState) => {
      return {
        passwordError: !prevState.password,
        firstNameError: !prevState.firstname,
        lastNameError: !prevState.lastname,
        emailError: !prevState.email || !(/\S+@\S+\.\S+/.test(prevState.email)),
      };
    }, () => {
      if (
        !this.state.passwordError
        && !this.state.emailError
        && !this.state.firstNameError
        && !this.state.lastNameError
      ) {
        const object = {
          firstName: this.state.firstname,
          lastName: this.state.lastname,
          email: this.state.email,
          password: this.state.password,
        };
        this.props.userData(object);
        this.props.switchModal('Register2');
      }
    });
  }

  render() {
    return (
      <div className="modal">
        <img className="x-icon" onClick={this.props.closeModal} src={X} alt="x" />
        <div className="sign-in-container">
          <img src={Girl} alt="person" />
          <div className="sign-in-body">
            <div className="sign-in-header">
              Create an Account
            </div>
            <div className="sign-in-text">
              Start the journey to understanding your brain!
            </div>
            <div className="form-container">
              <div className="sign-in-split-row">
                <div className="sign-in-form-row">
                  <label htmlFor="e-name" className="label-style">First Name</label>
                  {this.state.firstNameError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                  <input
                    type="text"
                    id="fname"
                    name="firstname"
                    className="sign-in-form-input  small-input"
                    autoComplete="off"
                    value={this.state.firstname}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="sign-in-form-row">
                  <label htmlFor="e-name" className="label-style">Last Name</label>
                  {this.state.lastNameError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                  <input
                    type="text"
                    id="lname"
                    name="lastname"
                    className="sign-in-form-input  small-input"
                    autoComplete="off"
                    value={this.state.lastname}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="sign-in-form-row">
                <label htmlFor="e-name" className="label-style">Email</label>
                {this.state.emailError ? <p className="modal-form-error">This email is not valid</p> : null}
                <input
                  type="text"
                  id="ename"
                  name="email"
                  className="sign-in-form-input"
                  autoComplete="off"
                  value={this.state.email}
                  onChange={this.handleChange}
                />
              </div>
              <div className="sign-in-form-row">
                <label htmlFor="e-pass" className="label-style">Password</label>
                {this.state.passwordError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="sign-in-form-input"
                  autoComplete="off"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
              </div>
              {/* <div className="forgot" onClick={this.security} role="button" tabIndex={0}>
                I have read and accepted the Terms of Service and Privacy Policy
              </div> */}
              <div className="sign-in-bubble">
                <input type="button" value="Next" className="sign-in-button" onClick={() => { this.handleNext(); }} />
              </div>
              <div className="invite">
                Already have an Account?
              </div>
              <div
                className="click-me"
                role="button"
                tabIndex={0}
                onClick={() => { this.props.switchModal('SignIn'); }}
              >
                Sign In
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    email: state.user.email,
  }
);

export default connect(mapStateToProps, { closeModal, userData, switchModal })(Register1);
